import { render, staticRenderFns } from "./SellerDashboard.vue?vue&type=template&id=61ab1975&scoped=true"
import script from "./SellerDashboard.vue?vue&type=script&lang=js"
export * from "./SellerDashboard.vue?vue&type=script&lang=js"
import style0 from "./SellerDashboard.vue?vue&type=style&index=0&id=61ab1975&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ab1975",
  null
  
)

export default component.exports